import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { UpdateIndicatorResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

type UpdateIndicatorResultInput = {
  id: string;
  Description?: string | null;
  ResultDate: string;
  TargetValueNum?: number | null;
  TargetValueTxt?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useUpdateIndicatorResultTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.indicator.updateResult.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey:
            trpc.frontend.indicator.indicatorResultsByIndicatorId.queryKey(),
        });
      },
    }),
  });

  return {
    updateIndicatorResult: async (
      variables: UpdateIndicatorResultInput
    ): Promise<UpdateIndicatorResultMutation> => {
      const { id, ...rest } = variables;
      const result = await mutation.mutateAsync({ Id: id, ...rest });

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};

const mapTrpcResponseToGraphQL = (trpcData: {
  Id: string;
}): UpdateIndicatorResultMutation => {
  return {
    update_indicator_result: {
      __typename: 'indicator_result_mutation_response',
      returning: [
        {
          __typename: 'indicator_result',
          Id: trpcData.Id,
        },
      ],
    },
  };
};
